import { render, staticRenderFns } from "./ServiceResourcePresets.vue?vue&type=template&id=114f559f"
import script from "./ServiceResourcePresets.vue?vue&type=script&lang=js"
export * from "./ServiceResourcePresets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports